import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import {
  TbChevronLeft,
  TbChevronRight,
  TbChevronsLeft,
  TbChevronsRight,
} from 'react-icons/tb';
import classNames from 'classnames';
import _ from 'lodash';

function TablePagination({ onOffsetChange, offset = 0, pageSize = 50, total = 0 }) {
  const pageSizeNum = Number(pageSize);
  const totalPages = Math.ceil(total / pageSizeNum);

  if (totalPages <= 1) return null;

  const currentPage = offset;
  const lastPage = totalPages - 1;

  const canPreviousPage = currentPage > 0;
  const canNextPage = currentPage < lastPage;

  const pageRange = _.range(totalPages);
  const visiblePages =
    totalPages <= 5
      ? pageRange
      : pageRange.filter((page) => Math.abs(page - currentPage) <= 2);

  const hasPreviousEllipsis = visiblePages[0] > 0;
  const hasNextEllipsis = visiblePages[visiblePages.length - 1] < lastPage;

  return (
    <Row className={classNames('align-items-center', 'justify-content-end')}>
      <Col sm="auto">
        <ul className="pagination pagination-boxed mb-0 justify-content-center">
          <li className="page-item">
            <button
              type="button"
              className="page-link"
              onClick={() => onOffsetChange(0)}
              disabled={!canPreviousPage}
            >
              <TbChevronsLeft />
            </button>
          </li>
          <li className="page-item">
            <button
              type="button"
              className="page-link"
              onClick={() => onOffsetChange(currentPage - 1)}
              disabled={!canPreviousPage}
            >
              <TbChevronLeft />
            </button>
          </li>

          {hasPreviousEllipsis && (
            <li className="page-item disabled">
              <span className="page-link">...</span>
            </li>
          )}

          {visiblePages.map((page) => (
            <li
              key={page}
              className={classNames('page-item', { active: currentPage === page })}
            >
              <button type="button" className="page-link" onClick={() => onOffsetChange(page)}>
                {page + 1}
              </button>
            </li>
          ))}

          {hasNextEllipsis && (
            <li className="page-item disabled">
              <span className="page-link">...</span>
            </li>
          )}

          <li className="page-item">
            <button
              type="button"
              className="page-link"
              onClick={() => onOffsetChange(currentPage + 1)}
              disabled={!canNextPage}
            >
              <TbChevronRight />
            </button>
          </li>
          <li className="page-item">
            <button
              type="button"
              className="page-link"
              onClick={() => onOffsetChange(lastPage)}
              disabled={!canNextPage}
            >
              <TbChevronsRight />
            </button>
          </li>
        </ul>
      </Col>
    </Row>
  );
}

TablePagination.defaultProps = {
  offset: 0,
  pageSize: 50,
  total: 0,
};

TablePagination.propTypes = {
  onOffsetChange: PropTypes.func.isRequired,
  offset: PropTypes.number,
  pageSize: PropTypes.number,
  total: PropTypes.number,
};

export default TablePagination;
